import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      alignSelf: 'center',
      width: '90%',
      padding: 1,
      borderRadius: 50,
      background: '#3845re',
      height: 4,
      '& .MuiLinearProgress-root': {
        borderRadius: 50,
        background: '#384558',
        width: 320,
      },

      '& .MuiLinearProgress-bar ': {
        borderRadius: 50,
        backgroundColor: COLORS.PRIMARY,
      },
    },
  }),
);
